module.exports = __webpack_public_path__ + "img/image-12.3462c259.jpeg";